import { render, staticRenderFns } from "./importdeletestaffs.vue?vue&type=template&id=0bddb744&"
import script from "./importdeletestaffs.vue?vue&type=script&lang=js&"
export * from "./importdeletestaffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports